module.exports = { "default": require("core-js/library/fn/symbol/species"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/symbol/species.js
// module id = 510
// module chunks = 158